module.exports = __webpack_public_path__ + "static/fipccartoongiraffeprint-c33ce4993453caeff164cfddd3a24016.jpeg";